import React, { useEffect, useState } from 'react';
import useAuth from '../context/AuthProvider';
import { TaxesAndFeeScheduleList } from '../components/Lists/TaxesAndFeeFilinsScheduleList';
import { apiClient } from '../helper/api';

import type { FilingScheduleStateOption } from '../components/Lists/TaxesAndFeeFilinsScheduleList';

export const TaxesAndFeesFilingSchedule: React.FC = () => {
    const { user } = useAuth();
    const token = user?.token;

    const [stateScheduleList, setStateScheduleList] = useState<unknown[]>([]);
    const [states, setStates] = useState<FilingScheduleStateOption[]>([]);
    const [sortModel, setSortModel] = useState([{ field: '', sort: '' }]);

    const fetchStateSchedules = () => {
        apiClient('/TaxesAndFeesFilingSchedule/getAllTaxesAndFilingSchedule', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }),
        }).then((responseJson) => {
            if (!responseJson) return;
            if (responseJson.data != null) {
                setStateScheduleList(responseJson.data);
            }
        });
    };

    const fetchStates = () => {
        apiClient('/States/getStates', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }),
        }).then((responseJson) => {
            if (!responseJson) return;
            if (responseJson.data != null) {
                setStates(responseJson.data);
            }
        });
    };

    useEffect(() => {
        fetchStates();
        fetchStateSchedules();
    }, []);

    return (
        <TaxesAndFeeScheduleList
            taxesAndFeeList={stateScheduleList as never}
            fetchData={fetchStateSchedules}
            states={states}
            sortModel={sortModel}
            setSortModel={setSortModel}
        />
    );
};

export const TaxesAndFeesFliingSchedule = TaxesAndFeesFilingSchedule;
